<template>
  <v-app id="app">
    <Loader />
    <Dialog />
    
    <Navbar v-if="renderNavBar" />
    <NavbarGuest v-if="renderNavBarGuest" />
    
    <AdminSidebar v-if="renderSideBar && $store.state.loggedInAs == 'ADMIN'" />
    <VendorSidebar v-if="renderSideBar && $store.state.loggedInAs == 'VENDOR'" />

    <v-container v-if="noScroll">
      <router-view/>
    </v-container>
    <v-container fluid v-else @click="closeDrawer">
      <v-main>
        <router-view/>
      </v-main>
    </v-container>
  </v-app>
</template>

<script>
import Navbar from './../components/Navbar';
import NavbarGuest from './../components/NavbarGuest'
import AdminSidebar from './../components/AdminSidebar';
import VendorSidebar from './../components/VendorSidebar';
import Loader from "@/components/Loader";
import Dialog from './../components/Dialog'

export default {
  components:  {
    Navbar,
    NavbarGuest,
    AdminSidebar,
    VendorSidebar,
    Loader,
    Dialog
  },
  data() {
    return {
      renderNavBar: false,
      renderNavBarGuest: false,
      renderSideBar: false,
      renderContainer: false,
      noScroll: false
    }
  },
  beforeUpdate() {
    if (this.$route && this.$route.meta) {
      this.renderNavBar = this.$route.meta.renderNavBar || false
      this.renderNavBarGuest = this.$route.meta.renderNavBarGuest || false
      this.renderSideBar = this.$route.meta.renderSideBar || false
      this.noScroll = this.$route.meta.noScroll || false
    }
  },
  methods: {
    closeDrawer() {
      window.getApp.$emit('APP_DRAWER_CLOSED');
    }
  }
}
</script>